export function isImage(file) {
  return file?.type?.startsWith("image/");
}

export function isPdf(file) {
  return (
    file?.type === "application/pdf" ||
    file?.name?.toLowerCase().endsWith(".pdf")
  );
}

export function previewUrl(file) {
  if (!file) return null;
  if (isImage(file)) return URL.createObjectURL(file);
  return null;
}
